import React from 'react';
export function BonusesSection() {
  return <section className="py-20 px-5 bg-cream text-center reveal" data-id="element-19">
      <h2 className="font-playfair text-[clamp(1.8rem,3.5vw,2.6rem)] font-bold text-text-dark mb-3.5 leading-[1.2]" data-id="element-20">
        y ademas hoy incluimos estos Bonos
      </h2>
      <p className="font-lora text-base text-text-mid max-w-[500px] mx-auto mb-10 leading-relaxed italic" data-id="element-21">
        Totalmente gratis. Sin costos extra.
      </p>

      <div className="max-w-[640px] mx-auto flex flex-col gap-4" data-id="element-22">
        {/* Bonus 1 */}
        <div className="bg-white border border-forest/10 rounded-xl py-5 px-6 flex items-start gap-4 text-left shadow-[0_2px_12px_rgba(30,45,36,0.05)] transition-transform duration-200 hover:translate-x-1" data-id="element-23">
          <div className="w-16 h-16 rounded-lg shrink-0 overflow-hidden" data-id="element-24">
            <img src="https://cdn.magicpatterns.com/uploads/dfu5ZeUK7jynYYKTYrP5xq/bono_1.png" alt="Juegos Fonológicos" className="w-full h-full object-cover" data-id="element-25" />
          </div>
          <div className="flex-1" data-id="element-26">
            <div className="font-playfair text-[1.05rem] font-bold text-text-dark mb-1" data-id="element-27">
              Juegos Fonológicos
            </div>
            <div className="text-[0.83rem] text-forest italic font-lora mb-2" data-id="element-28">
              12 juegos que hacen que tu hijo te pida practicar en vez de
              escaparse
            </div>
            <div className="flex flex-wrap gap-1.5" data-id="element-29">
              <span className="text-[0.72rem] bg-cream-dark text-text-mid py-0.5 px-2.5 rounded-full" data-id="element-30">
                Refuerza la base sonora
              </span>
              <span className="text-[0.72rem] bg-cream-dark text-text-mid py-0.5 px-2.5 rounded-full" data-id="element-31">
                Actividades simples
              </span>
              <span className="text-[0.72rem] bg-cream-dark text-text-mid py-0.5 px-2.5 rounded-full" data-id="element-32">
                Enfoque progresivo
              </span>
            </div>
          </div>
          <div className="text-right shrink-0" data-id="element-33">
            <div className="text-[0.8rem] text-text-light line-through" data-id="element-34">
              $15.000
            </div>
            <div className="text-[0.9rem] font-bold text-forest" data-id="element-35">GRATIS</div>
          </div>
        </div>

        {/* Bonus 2 */}
        <div className="bg-white border border-forest/10 rounded-xl py-5 px-6 flex items-start gap-4 text-left shadow-[0_2px_12px_rgba(30,45,36,0.05)] transition-transform duration-200 hover:translate-x-1" data-id="element-36">
          <div className="w-16 h-16 rounded-lg shrink-0 overflow-hidden" data-id="element-37">
            <img src="https://cdn.magicpatterns.com/uploads/mEYvB8WAaU1GoSpySrAsXN/bono_2.png" alt="Calendario Visual de Progreso" className="w-full h-full object-cover" data-id="element-38" />
          </div>
          <div className="flex-1" data-id="element-39">
            <div className="font-playfair text-[1.05rem] font-bold text-text-dark mb-1" data-id="element-40">
              Calendario Visual de Progreso
            </div>
            <div className="text-[0.83rem] text-forest italic font-lora mb-2" data-id="element-41">
              Para que tu hijo vea su avance y quiera seguir — el motor secreto
              de la constancia
            </div>
            <div className="flex flex-wrap gap-1.5" data-id="element-42">
              <span className="text-[0.72rem] bg-cream-dark text-text-mid py-0.5 px-2.5 rounded-full" data-id="element-43">
                Seguimiento claro
              </span>
              <span className="text-[0.72rem] bg-cream-dark text-text-mid py-0.5 px-2.5 rounded-full" data-id="element-44">
                Refuerza autoestima
              </span>
              <span className="text-[0.72rem] bg-cream-dark text-text-mid py-0.5 px-2.5 rounded-full" data-id="element-45">
                Estructura diaria
              </span>
            </div>
          </div>
          <div className="text-right shrink-0" data-id="element-46">
            <div className="text-[0.8rem] text-text-light line-through" data-id="element-47">
              $15.000
            </div>
            <div className="text-[0.9rem] font-bold text-forest" data-id="element-48">GRATIS</div>
          </div>
        </div>

        {/* Bonus 3 */}
        <div className="bg-white border border-forest/10 rounded-xl py-5 px-6 flex items-start gap-4 text-left shadow-[0_2px_12px_rgba(30,45,36,0.05)] transition-transform duration-200 hover:translate-x-1" data-id="element-49">
          <div className="w-16 h-16 rounded-lg shrink-0 overflow-hidden" data-id="element-50">
            <img src="https://cdn.magicpatterns.com/uploads/96fDpVbgg8i6HHNC7BA3Uy/bono_3.png" alt="Mini Biblioteca Inicial" className="w-full h-full object-cover" data-id="element-51" />
          </div>
          <div className="flex-1" data-id="element-52">
            <div className="font-playfair text-[1.05rem] font-bold text-text-dark mb-1" data-id="element-53">
              Mini Biblioteca Inicial
            </div>
            <div className="text-[0.83rem] text-forest italic font-lora mb-2" data-id="element-54">
              Textos decodificables que tu hijo puede leer solo desde la semana
              3 — sin frustración
            </div>
            <div className="flex flex-wrap gap-1.5" data-id="element-55">
              <span className="text-[0.72rem] bg-cream-dark text-text-mid py-0.5 px-2.5 rounded-full" data-id="element-56">
                Textos decodificables
              </span>
              <span className="text-[0.72rem] bg-cream-dark text-text-mid py-0.5 px-2.5 rounded-full" data-id="element-57">
                Sin frustración
              </span>
              <span className="text-[0.72rem] bg-cream-dark text-text-mid py-0.5 px-2.5 rounded-full" data-id="element-58">
                Lectura progresiva
              </span>
            </div>
          </div>
          <div className="text-right shrink-0" data-id="element-59">
            <div className="text-[0.8rem] text-text-light line-through" data-id="element-60">
              $15.000
            </div>
            <div className="text-[0.9rem] font-bold text-forest" data-id="element-61">GRATIS</div>
          </div>
        </div>

        {/* Bonus 4 */}
        <div className="bg-white border border-forest/10 rounded-xl py-5 px-6 flex items-start gap-4 text-left shadow-[0_2px_12px_rgba(30,45,36,0.05)] transition-transform duration-200 hover:translate-x-1" data-id="element-62">
          <div className="w-16 h-16 rounded-lg shrink-0 overflow-hidden" data-id="element-63">
            <img src="https://cdn.magicpatterns.com/uploads/6Q3UY2GUPJj39yCmBxP2no/bono_4.png" alt="Audio Calmante Guiado" className="w-full h-full object-cover" data-id="element-64" />
          </div>
          <div className="flex-1" data-id="element-65">
            <div className="font-playfair text-[1.05rem] font-bold text-text-dark mb-1" data-id="element-66">
              Audio Calmante Guiado
            </div>
            <div className="text-[0.83rem] text-forest italic font-lora mb-2" data-id="element-67">
              Para los días difíciles: 5 minutos que bajan la tensión y preparan
              a tu hijo para aprender
            </div>
            <div className="flex flex-wrap gap-1.5" data-id="element-68">
              <span className="text-[0.72rem] bg-cream-dark text-text-mid py-0.5 px-2.5 rounded-full" data-id="element-69">
                Acompañamiento emocional
              </span>
              <span className="text-[0.72rem] bg-cream-dark text-text-mid py-0.5 px-2.5 rounded-full" data-id="element-70">
                Reduce tensión
              </span>
              <span className="text-[0.72rem] bg-cream-dark text-text-mid py-0.5 px-2.5 rounded-full" data-id="element-71">
                Genera seguridad
              </span>
            </div>
          </div>
          <div className="text-right shrink-0" data-id="element-72">
            <div className="text-[0.8rem] text-text-light line-through" data-id="element-73">
              $15.000
            </div>
            <div className="text-[0.9rem] font-bold text-forest" data-id="element-74">GRATIS</div>
          </div>
        </div>
      </div>
    </section>;
}